/* What a trade says to each end of it.

   `user_traded` used to carry the game and nothing else, so an ally's gift simply appeared in the
   recipient's total — indistinguishable from a good harvest — and the sender had no confirmation it
   had gone anywhere. The server now names who sent what; this turns that into a sentence.

   A leaf module for the usual reason: importing a store barrel drags in the whole app graph, and
   this is the part worth testing on its own. */

const amounts = ({ food, researchPoints, foodLabel }) => {
  const parts = []
  if (food > 0) parts.push(`${food} ${foodLabel}`)
  if (researchPoints > 0) parts.push(`${researchPoints} research`)
  return parts.join(" and ")
}

export const describeTrade = ({ message, userId, usernameFor, team }) => {
  const food = Number(message?.food || 0)
  const researchPoints = Number(message?.research_points || 0)
  if (food <= 0 && researchPoints <= 0) return null

  const foodLabel = team === "human" ? "food" : "meat"
  const what = amounts({ food, researchPoints, foodLabel })

  // Teammates other than the two involved also receive this — it goes to the team group — and a
  // third player being told "you received" would be simply false.
  if (message.to_user === userId) {
    return { type: "success", text: `${usernameFor(message.from_user)} sent you ${what}.` }
  }
  if (message.from_user === userId) {
    return { type: "info", text: `You sent ${what} to ${usernameFor(message.to_user)}.` }
  }
  return {
    type: "info",
    text: `${usernameFor(message.from_user)} sent ${what} to ${usernameFor(message.to_user)}.`,
  }
}

export default describeTrade
